import { useFriendship } from '@/friendships/FriendshipContext';
import Share from '@/shares/Share';
import Upload from '@/uploads/Upload';

const Frame = ({ upload }) => {
  const friendship = useFriendship();
  if (friendship) {
    return <Share {...{ friendship, upload }} />;
  } else {
    return <Upload {...{ upload }} />;
  }
};

export default Frame;
